/**
 * AlmadarPostComplianceAsCodeENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostComplianceAsCodeENPostPage
 */

import { useAlmadarPostComplianceAsCodeENPostPageLogic } from '@/hooks/traits/useAlmadarPostComplianceAsCodeENPostPageLogic';
import type { AlmadarPostComplianceAsCodeENPostPageConfig } from '@/hooks/traits/useAlmadarPostComplianceAsCodeENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostComplianceAsCodeENPostView as AlmadarPostComplianceAsCodeENPostViewEntity } from '@app/shared';
import { AlmadarPostComplianceAsCodeENPostHeaderView } from '@/components/traits/AlmadarPostComplianceAsCodeENPostHeaderView';
import { Stack } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { AlmadarPostComplianceAsCodeENPostView } from '@/components/traits/AlmadarPostComplianceAsCodeENPostView';
import { AlmadarPostComplianceAsCodeENPostFooterView } from '@/components/traits/AlmadarPostComplianceAsCodeENPostFooterView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostComplianceAsCodeENPostPageViewProps {
  config?: Partial<AlmadarPostComplianceAsCodeENPostPageConfig>;
}

export function AlmadarPostComplianceAsCodeENPostPageView({ config: propsConfig }: AlmadarPostComplianceAsCodeENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostComplianceAsCodeENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostComplianceAsCodeENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostComplianceAsCodeEN" trait="AlmadarPostComplianceAsCodeENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostComplianceAsCodeENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostComplianceAsCodeENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} bg="transparent" paddingY="xl"><Container maxWidth="xl" size="xl" padding="lg"><AlmadarPostComplianceAsCodeENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostComplianceAsCodeENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostComplianceAsCodeENPostPageView;
